import React from 'react';
import { Link } from 'react-router-dom';

const ForgotPassword = () => {
  return (
    <div>
      <h2>
        Em construção...
      </h2>
      <Link to="/login">
        Voltar
      </Link>
    </div>
  )
}

export default ForgotPassword;